import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const items = [
  { id: "price_1R9jAeJghU42dndgldb2W7Ca", image: "/mainImages/LSR-Aware-PC.png", price: 10 },
  { id: "price_1R9jAYJghU42dndgzSP96dUZ", image: "/mainImages/LSR-Pro-PC.png", price: 30 },
  { id: "price_1R9jAPJghU42dndgvedAAupQ", image: "/mainImages/LSR-Roads-PC.png", price: 30 },

    { id: "price_1RGJDKJghU42dndguIHX6f98", image: "/bundleimages/bundleaware.png", price: 65 },

  { id: "price_1R9jAGJghU42dndgh1ALXi3R", image: "/mainImages/Driving-Aware-All-Roads-PC.png", price: 15 },
  { id: "price_1R9jA5JghU42dndgu8epBXKo", image: "/mainImages/DrivingPro-Black-Top-PC.png", price: 25 },
  { id: "price_1R9j9yJghU42dndgG9etv8zj", image: "/mainImages/DrivingPro-Graded-Road-PC.png", price: 30 },

  { id: "price_1RGJDHJghU42dndgYJcgnVLl", image: "/bundleimages/bundleaware.png", price: 60 },

  { id: "price_1R9j9jJghU42dndgz4dlC055", image: "/bundleimages/processsafetylockout.png", price: 50 },
  { id: "price_1RGJCgJghU42dndgk4Gus1fU", image: "/bundleimages/processafetygrey.png", price: 0.0 },

];


  

const BusinessPage = () => {
  const [quantities, setQuantities] = useState({});
  const navigate = useNavigate();

  const handleQtyChange = (id, value) => {
    if (/^\d*$/.test(value)) {
      if (id === 'price_1RGJCgJghU42dndgk4Gus1fU') {
        alert("Coming Soon! For more information, please contact info@virsatAcademy.com.");
        return; }
      setQuantities((prev) => ({ ...prev, [id]: value ? parseInt(value) : 0 }));
    }
  };

  const totalPrice = items.reduce((total, item) => {
    return total + (quantities[item.id] || 0) * item.price;
  }, 0);

  const handlePurchase = () => {
    const selectedItems = items
      .filter((item) => quantities[item.id] > 0)
      .map((item) => ({ id: item.id, quantity: quantities[item.id] }));
    
    navigate("/checkout", { state: { selectedItems } });
  };

  return (
    <div className="checkout-business">
      <h1>Purchase PC Business License</h1>
      <div className="checkout-container-business">
        {items.map((item) => (
          <div key={item.id} className="item">
            <img src={item.image} alt="Item" />
            <div className="inputBox">
              <div className="business-text">Qty 
                <input
                  type="number"
                  value={quantities[item.id] || ""}
                  onChange={(e) => handleQtyChange(item.id, e.target.value)}
                  min="0"
                />
                x {`$${item.price}`}
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="checkout-calculation-business">
       <div className="sub-cover">

        <div className="sub-checkout">
        <h1 className="checkout-h2">Total: ${totalPrice}</h1>

        <button className="body-button" onClick={handlePurchase} disabled={totalPrice === 0}>
          Purchase
        </button>
        <p className="checkout-sub-text"> Discount: Applied at checkout</p>

        </div>
       </div>
        <div className="purchase-text-below"> 
          <p> All PC licenses are valid for 30 days from the date of purchase and allows for 10 game runs. Each pin verification at start of game counts as one game run.</p>
        </div>
      </div>
    </div>
  );
};

export default BusinessPage;
